module.exports = __webpack_public_path__ + "assets/mail.17ab13af.svg";